import ThemePage from '@/components/Theme/ThemePage'

const page = () => {
  return <ThemePage />
}
export default page
